import React from "react";
import Msg from "./Msg";
import Both from "./Both";
import Media from "./Media";
import { DocumentData } from "firebase/firestore";

interface Props {
  admin: boolean;
  task: DocumentData;
  project: DocumentData;
  messages: DocumentData[];
}

function Proofs({ messages, project, task, admin }: Props) {
  return (
    <div className="w-[98%] h-full flex items-start justify-start flex-col">
      {messages.length === 0 && (
        <div className="w-full h-full flex items-center justify-center">
          <span className="text-[14px] text-gray-400">Aucun message</span>
        </div>
      )}
      {messages.length > 0 &&
        // eslint-disable-next-line array-callback-return
        messages.map((obj: any) => {
          if (obj.type === "message") {
            return <Msg key={obj.id} {...obj} task={task} project={project} />;
          } else if (obj.type === "media") {
            return (
              <Media key={obj.id} {...obj} task={task} project={project} />
            );
          } else if (obj.type === "both") {
            return (
              <Both
                {...obj}
                section="Justificatifs"
                admin={admin}
                userId={obj.userId}
                task={task}
                key={obj.id}
                project={project}
              />
            );
          }
        })}
    </div>
  );
}

export default Proofs;
